<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="xl"
		title="Monedas y tipos de cambio"
	>
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-form @submit="updateCurrenciesSettings">
			<b-row>
				<b-col lg="3">
					<FormGroupBox title="Monedas">
						<b-form-checkbox-group
							switches
							size="lg"
							v-model="myCurrencies.currencies"
							:options="$root.auxVars.currencyOpts"
						>

						</b-form-checkbox-group>
					</FormGroupBox>
				</b-col>
				<b-col lg="9">
					<FormGroupBox title="Tipos de cambio">
						<b-form-row
							class="mt-2 d-flex align-items-center text-center"
							v-for="(comb,i) in exchangeRatesCombinations"
							:key="i"
						>
							<b-col cols="4" >
								<span class="h4"><strong class="text-uppercase">{{comb.fromCurrencyCode}}</strong> to <strong class="text-uppercase">{{comb.toCurrencyCode}}</strong></span>
							</b-col>
							<b-col cols="1">
								<span class="h4"><md-icon icon="chevron_right" /></span>
							</b-col>
							<b-col cols="2">
								<b-form-select
									size="sm"
									v-model="comb.unitCurrency"
									:options="[{value:'from',text:`1 ${comb.fromCurrencyCode.toUpperCase()}`},{value:'to',text:`1 ${comb.toCurrencyCode.toUpperCase()}`},]"
								/>
							</b-col>
							<b-col cols="1" >
								<span class="h3">=</span>
							</b-col>
							<b-col>
								<b-input-group size="sm">
									<template #prepend><b-input-group-text>$</b-input-group-text></template>
									<b-form-input type="number" v-model="comb.amount" size="sm" required step=".001"/>
									<template #append><b-input-group-text class="text-uppercase">{{comb.unitCurrency == 'from' ? comb.toCurrencyCode : comb.fromCurrencyCode}}</b-input-group-text></template>
								</b-input-group>
							</b-col>
						</b-form-row>
					</FormGroupBox>
				</b-col>
			</b-row>
			<div class="text-right">
				<b-button type="submit" variant="primary">Actualizar</b-button>
			</div>
		</b-form>
	</b-modal>
</template>

<script>
import FormGroupBox from '@/components/helpers/FormGroupBox'

export default {
	props: {
		successCallback: {
			type : Function,
			required: false,
			default: () => {}
		}
	},
	components: { FormGroupBox},
	data(){
		let defaultSettings = {
			currencies: [
				'usd',
			],
		}
		return {
			ratePlans: [],
			loading: true,
			myCurrencies: {...defaultSettings},
			modelExchangeRates: [],
			exchangeRatesCombinations: []
		}
	},
	computed: {
		currenciesOpts() {
			return this.myCurrencies.currencies
		},
	},
	methods:{
		updateCurrenciesSettings(ev) {
			// actualiza las monedas validas y después los tipos de cambio
			ev.preventDefault()
			this.loading = true
			this.$root.api.put('currencies',{ settings : {currencies:this.myCurrencies.currencies} }).then(() => {
				this.$root.api.put('exchange-rates',{ exchangeRates : this.exchangeRatesCombinations }).then(() => {
					this.$root.showAlert('Tipos de cambio actualizado')
					this.loadExchangeRates()
					this.loading = false
				}).catch(this.$root.handleRequestError);
			}).catch(this.$root.handleRequestError);
		},
		generateExchangeRatesCombinations() {
			// distinc de las monedas de las tarifas
			let ratesCurrencies = []
			this.ratePlans.forEach(rp => {
				if(rp.active && !ratesCurrencies.includes(rp.currency)) ratesCurrencies.push(rp.currency)
			})
			// generar combinaciones para tipos de cambio de monedas de tarifas a monedas disponibles en el punto de venta
			let combinations = []
			ratesCurrencies.forEach(rc => {
				this.myCurrencies.currencies.forEach(vc => {
					if (rc != vc) {
						let exchangeRate = this.modelExchangeRates.find(er => er.fromCurrencyCode == rc && er.toCurrencyCode == vc)
						combinations.push({
							fromCurrencyCode:rc,
							toCurrencyCode:vc,
							amount: exchangeRate ? exchangeRate.amount : 0,
							unitCurrency: exchangeRate ? exchangeRate.unitCurrency : 'from',
						})
					}
				})
			})
			this.exchangeRatesCombinations = combinations
		},
		loadModel(){
			this.$refs['modal-view'].show()
			this.fetchModel()
		},
		fetchModel(){
			this.loading = true
			this.$root.api.get('currencies').then((res) => {
				this.myCurrencies = {...res.data}
				this.loadRatePlans()
				this.loadExchangeRates()
				this.loading = false
			}).catch(this.$root.handleRequestError);
		},
		loadRatePlans(){
			this.$root.api.get('rates').then((res) => {
				this.ratePlans = res.data.rows
			}).catch(this.$root.handleRequestError);
		},
		loadExchangeRates() {
			this.$root.api.get('exchange-rates').then((res) => {
				this.modelExchangeRates = res.data
			}).catch(this.$root.handleRequestError)
		},
	},
	mounted() {
	},
	watch:{
		modelExchangeRates: function(){
			this.generateExchangeRatesCombinations()
		},
		ratePlans: {
			handler(){
				this.generateExchangeRatesCombinations()
			},
			deep:true,
		},
		currenciesOpts: function(){
			this.generateExchangeRatesCombinations()
		},
	}
}
</script>
